import React, { createContext, useContext, useEffect, useState } from 'react';

import { useSearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import { Filters, FilterType } from 'features/Filters/types/Filters';
import { defaultFilters } from 'features/Filters/utils/defaultFilters';
import { toFilters } from 'utils/searchParamsConverter';

const FilterContext = createContext<{
  filters: Filters;
  setFilters: (filters: Filters) => void;
  currentFiltersPage: FilterType;
  setCurrentFiltersPage: (page: FilterType) => void;
}>({
  filters: defaultFilters,
  setFilters: () => {},
  currentFiltersPage: FilterType.FRAMES,
  setCurrentFiltersPage: () => {},
});

export const useFilters = () => useContext(FilterContext);

type FilterProviderProps = {
  children: React.ReactNode;
};

export const FilterProvider = ({ children }: FilterProviderProps) => {
  const { searchParams, updateFiltersSearchParams } = useSearchParamsProvider();
  const [filters, setFilters] = useState<Filters>(defaultFilters);
  const [currentFiltersPage, setCurrentFiltersPage] = useState<FilterType>(FilterType.FRAMES);

  useEffect(() => {
    const filtersFromSearchParams = toFilters(searchParams);
    setFilters(filtersFromSearchParams);
  }, [searchParams]);

  const updateFilters = (newFilters: Filters) => {
    setFilters(newFilters);
    updateFiltersSearchParams(newFilters);
  };

  return (
    <FilterContext.Provider
      value={{
        filters,
        setFilters: updateFilters,
        currentFiltersPage,
        setCurrentFiltersPage,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};
